import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice: (state) => state.api.server.resizeStorage,
	actionType: 'SERVER_RESIZE_STORAGE',
	method: 'POST',
	url: '/server/resizeStorage.json',
});

export { actions, reducer, sagas, selectors };
